import { Inject, Injectable, NgZone } from '@angular/core';
import { SessionService } from './session.service';
import { TranslateService } from '@ngx-translate/core';
import { LIVECHAT_VERSION } from 'src/app/shared/utils/livechat_version';

@Injectable({
  providedIn: 'root',
})
export class BeamerService {
  constructor(
    private sessionService: SessionService,
    private translateService: TranslateService,
    private zone: NgZone,
    @Inject(LIVECHAT_VERSION) private version: string
  ) {}

  public initBeamer() {
    this.zone.runOutsideAngular(() => {
      if ((<any>window).Beamer) {
        const session = this.sessionService.get();
        const user = session?.user!;

        const name = user.name || '';
        const [firstName, ...lastNames] = name.split(' ');
        const joinedLastNames = lastNames.join(' ');

        const language = this.translateService.currentLang || '';
        const [formattedLanguage] = language.toUpperCase().split('_');

        const beamerConfiguration = {
          selector: '.beamerTrigger',
          user_id: user.email,
          user_email: user.email,
          user_firstname: firstName,
          user_lastname: joinedLastNames,
          language: formattedLanguage,
          company_ids:
            user && user.companiesIds ? user.companiesIds.join(';') : null,
          new_livechat: true,
          app_version: this.version,
        };

        (<any>window).Beamer.init();
        (<any>window).Beamer.update(beamerConfiguration);
      }
    });
  }
  
}
